<template>
    <div class="imageCropping">
        <el-upload
          class="avatar-uploader upload" 
          :action="avatarUploadUrl" 
          :show-file-list="false" 
          :before-upload="beforeAvatarUpload">
            <img v-if="avatar" :src="avatar" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <el-dialog
          class="avatarDialog"
          title="截取图片"
          :visible.sync="dialogVisible"
          :close-on-click-modal="false"
          append-to-body
          width="35%">
            <vueCropper
              ref="cropper"
              :img="imgData"
              :info="option.info"
              :size="option.size"
              :full="option.full"
              :fixed="option.fixed"
              :fixedNumber="option.fixedNumber"
              :outputSize="option.size"
              :outputType="option.outputType"
              :autoCrop="option.autoCrop"
              :fixedBox="option.fixedBox"
              :centerBox="option.centerBox"
              :original="option.original"
              :canMoveBox="option.canMoveBox"
              :canScale="option.canScale"
              :autoCropWidth="option.autoCropWidth"
              :autoCropHeight="option.autoCropHeight">
            </vueCropper>
            <span slot="footer" class="dialog-footer">
                <el-button @click="$refs.cropper.rotateLeft()">左转90度</el-button>
                <el-button @click="$refs.cropper.rotateRight()">右转90度</el-button>
                <el-button @click="submitIMGData">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import fileApi from '@/request/api/file';
import Operation from "@/request";

export default {
    props: {
        img: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            option: {
                img: '', // 裁剪图片的地址
                info: true, // 裁剪框的大小信息
                size: 1, // 剪切后的图片质量（0.1-1）
                full: true, // 输出原图比例截图 props名full
                fixed: true, //是否开启截图框宽高固定比例
                fixedNumber: [1, 1], //裁剪框比例
                outputType: 'png', // 裁剪生成图片的格式
                canMove: true,  // 能否拖动图片
                original: true,  // 上传图片是否显示原始宽高
                canMoveBox: true,  // 能否拖动截图框
                canScale: true,
                autoCrop: true, // 是否默认生成截图框
                autoCropWidth: 200, // 默认生成截图框宽度
                autoCropHeight: 200, // 默认生成截图框高度
                fixedBox: false, // 截图框固定大小
                centerBox: true
            },
            dialogVisible: false,
            imgData: "",
            avatar: "", //头像img
            avatarUploadUrl: "", //上传路径
        }
    },
    created() {
        if(this.img) {
            this.avatar = this.img;
        }
        this.getAvatarUploadUrl();
    },
    methods: {
        //拼接头像上传地址
        getAvatarUploadUrl(){
            this.avatarUploadUrl = Operation.Const.ApiUrl+"/upload";
        },
        //file转base64
        fileTransitionBase64(file) {
            var reader = new FileReader();
            // 传入一个参数对象即可得到基于该参数对象的文本内容
            reader.readAsDataURL(file);
            reader.onload = (e) => {
                // target.result 该属性表示目标对象的DataURL
                this.imgData = e.target.result;
                this.dialogVisible = true;
            };
        },
        //上传头像前的验证
        beforeAvatarUpload(file) {
            const isJPG = file.type.startsWith('image');
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
              this.$message.error('图片格式不正确');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            if(isLt2M) {
                this.fileTransitionBase64(file);
            }
            return false;
        },
        //保存图片
        submitIMGData() {
            if(this.$refs.cropper.cropH == 0) {
                this.$message({
                    message: '请正确截取图片',
                    type: 'warning'
                });
            } else {
                this.$refs.cropper.getCropData((data) => {
                    var arr = data.split(','), 
                        mime = arr[0].match(/:(.*?);/)[1],
                        bstr = atob(arr[1]), 
                        n = bstr.length, 
                        u8arr = new Uint8Array(n);
                    while(n--) {
                        u8arr[n] = bstr.charCodeAt(n);
                    }
                    var file = new File([u8arr], 'img.png', {type:mime});
                    const form = new FormData();
                    form.append("file", file);
                    fileApi.upload(form, res => {
                        if(res.data) {
                            this.avatar = res.data;
                            this.dialogVisible = false;
                            this.$emit('changeAvatar', res.data);
                        }
                    })
                })
            }
        },
    },
}
</script>
<style lang="scss">
.imageCropping {
    .avatar-uploader img {
        width: 80px;
        max-height: 80px;
        border: 2px solid #999999;
        border-radius: 50%;
        cursor: pointer;
    }
    .avatar-uploader-icon {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 50px;
        border: 1px dashed #ccc;
    }
    input[type="file"] {
        display: none;
    }
}
.avatarDialog {
    .el-dialog__body {
        height: 500px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/imageCropping.vue